export enum TextEnum {
  NOW = 'Now',
  HIGHLIGHTS = 'Todays Highlights',
  SUN = 'Sunrize & Sunset',
  SUNRISE = 'Sunrise:',
  SUNSET = 'Sunset:',
  FEELS_LIKE = 'Feels',
  WIND = 'Wind',
  HUMIDITY = 'Humidity',
  PRESSURE = 'Pressure'
}
